import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const ContactModal = ({ onClose }) => {
  const { colors } = useTheme();
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');
  const firstFieldRef = useRef(null);

  useEffect(() => {
    firstFieldRef.current?.focus();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (status === 'loading') {
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://formsubmit.co/ajax/gmvimarsh@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(onClose, 1800);
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Contact form"
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div
        className="relative w-full max-w-lg rounded-xl p-8 shadow-2xl"
        style={{ backgroundColor: colors.background }}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full bg-transparent p-2 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2"
          style={{
            color: colors.textSecondary,
            '--tw-ring-color': colors.accent
          }}
          aria-label="Close contact form"
        >
          ✕
        </button>

        <div className="mb-6 text-center">
          <h2 className="text-4xl font-black" style={{ color: colors.textPrimary }}>Send a message</h2>
          <p className="text-2xl" style={{ color: colors.textSecondary }}>Drop a note and it will show up in my inbox.</p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="flex flex-col">
            <label htmlFor="contact-name" className="text-3xl font-medium" style={{ color: colors.textSecondary }}>
              Name*
            </label>
            <input
              ref={firstFieldRef}
              id="contact-name"
              name="name"
              type="text"
              required
              value={formData.name}
              onChange={handleChange}
              className="mt-1 rounded-md border px-3 py-2 shadow-inner focus:outline-none focus:ring-2"
              style={{
                backgroundColor: colors.surface,
                borderColor: colors.accent,
                color: colors.textPrimary,
                '--tw-ring-color': colors.accent
              }}
              placeholder="Jane Doe"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="contact-email" className="text-3xl font-medium" style={{ color: colors.textSecondary }}>
              Email*
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="mt-1 rounded-md border px-3 py-2 shadow-inner focus:outline-none focus:ring-2"
              style={{
                backgroundColor: colors.surface,
                borderColor: colors.accent,
                color: colors.textPrimary,
                '--tw-ring-color': colors.accent
              }}
              placeholder="you@example.com"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="contact-message" className="text-3xl font-medium" style={{ color: colors.textSecondary }}>
              Message*
            </label>
            <textarea
              id="contact-message"
              name="message"
              rows={4}
              required
              value={formData.message}
              onChange={handleChange}
              className="mt-1 rounded-md border px-3 py-2 shadow-inner focus:outline-none focus:ring-2"
              style={{
                backgroundColor: colors.surface,
                borderColor: colors.accent,
                color: colors.textPrimary,
                '--tw-ring-color': colors.accent
              }}
              placeholder="What would you like to discuss?"
            />
          </div>

          <div className="flex items-center justify-between">

            <button
              type="submit"
              className="rounded-full border px-6 py-2 text-xl font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
              style={{
                borderColor: colors.accent,
                color: colors.accent,
                '--tw-ring-color': colors.accent
              }}
              disabled={status === 'loading'}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = colors.accent;
                e.target.style.color = colors.background;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = colors.accent;
              }}
            >
              {status === 'loading' ? 'Sending…' : 'Send message'}
            </button>
          </div>

          {status === 'success' && (
            <p className="text-center text-xl font-medium text-green-600">Message sent! Talk soon.</p>
          )}
          {status === 'error' && (
            <p className="text-center text-xl font-medium text-red-600">Something went wrong. Please try again.</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
